import type { ReactNode } from "react";
import { NavRail } from "./NavRail";
import { Topbar } from "./Topbar";
import { ContextStrip } from "./ContextStrip";
import type { RouteId } from "../../lib/routes";
import type { StatusCounts, ChecklistProgress } from "../../lib/boardUtils";

interface ShellProps {
  currentRoute: RouteId;
  onNavigate: (route: RouteId) => void;
  statusCounts: StatusCounts;
  checklistProgress: ChecklistProgress;
  sidebarExpanded: boolean;
  onToggleSidebar: () => void;
  onOpenSettings?: () => void;
  onOpenCommandPalette?: () => void;
  children: ReactNode;
}

export function Shell({ currentRoute, onNavigate, statusCounts, checklistProgress, sidebarExpanded, onToggleSidebar, onOpenSettings, onOpenCommandPalette, children }: ShellProps) {
  return (
    <div className="h-screen w-screen flex overflow-hidden bg-[var(--color-bg-canvas)] text-[var(--color-text-primary)]">
      {/* Navigation rail */}
      <NavRail
        currentRoute={currentRoute}
        onNavigate={onNavigate}
        expanded={sidebarExpanded}
        onToggleExpanded={onToggleSidebar}
        onOpenSettings={onOpenSettings}
      />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar currentRoute={currentRoute} onOpenCommandPalette={onOpenCommandPalette} />

        {/* Page content */}
        <main className="flex-1 overflow-hidden">
          {children}
        </main>

        <ContextStrip statusCounts={statusCounts} checklistProgress={checklistProgress} />
      </div>
    </div>
  );
}
